<script lang="ts">
  import type { ShellController } from './shell-controller.svelte';

  const { shell }: { shell: ShellController } = $props();

  let code = $state('');

  function onsubmit(event: SubmitEvent): void {
    event.preventDefault();
    void shell.redeem(code).then(() => {
      if (shell.redeemError === '') code = '';
    });
  }
</script>

<div class="wis-panel wis-panel--redeem">
  <div class="wis-row redeem__title">Redeem Code</div>
  <form id="redeem-form" {onsubmit} autocomplete="off">
    <input
      id="redeem-code"
      type="text"
      placeholder="Enter your code"
      maxlength="35"
      required
      bind:value={code}
    />
    <button class="wis-btn redeem__accept" type="submit" disabled={shell.busy}>Accept</button>
    <button
      class="wis-btn redeem__back"
      type="button"
      onclick={() => {
        shell.navigate('shop');
      }}>Back</button
    >
    <span
      class="wis-row redeem__result"
      class:redeem__result--bad={shell.redeemError !== ''}
      role="status">{shell.redeemError || shell.redeemMessage}</span
    >
  </form>
</div>

<style>
  .redeem__title {
    top: 15px;
    font-size: 16px;
  }

  #redeem-code {
    position: absolute;
    top: 45px;
    left: 98px;
  }

  .redeem__accept {
    position: absolute;
    top: 80px;
    left: 141px;
    width: 143px;
    height: 34px;
    padding: 0;
  }

  .redeem__back {
    position: absolute;
    top: 119px;
    left: 154px;
    width: 117px;
    height: 34px;
    padding: 0;
  }

  /* Under the plate, where nothing else is drawn — the plate itself has no room left. */
  .redeem__result {
    top: 160px;
    font-size: 12px;
    color: #fff;
    text-shadow: 0 1px 2px #000;
  }

  .redeem__result--bad {
    color: #ff3333;
  }
</style>
